export default __webpack_public_path__ + "static/media/modelGroup.48a23566.svg";